import axios from 'axios';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: ''
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const myAccountService = {
  getMyAccounts,
  getMyAccountHoldings
};

async function getMyAccounts({ asof }) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post(
    '/api/dataview/my-accounts',
    { asof }, // 👈 pass here
    requestOptions
  );

  return response.data;
}

// NEW
async function getMyAccountHoldings({ id, asof }) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post(
    '/api/dataview/my-account-holdings',
    {
      id,
      asof // backend will receive req.body.asof
    },
    requestOptions
  );

  return response.data;
}
